export const truckData = [
  {
    name: "Independent Stage 11 Titanium Truck Gold",
    price: "38",
    src: "truck-02.glb",
    thumbSrc: "truck-02-thumb.png",
  },
  {
    name: "Independent Stage 11 Titanium Truck White Painted",
    price: "38",
    src: "truck-04.glb",
    thumbSrc: "truck-04-thumb.png",
  },
  {
    name: "Independent Stage 11 Titanium Truck Natural",
    price: "30",
    src: "truck-01.glb",
    thumbSrc: "truck-01-thumb.png",
  },
  {
    name: "Independent Stage 11 Titanium Truck Red",
    price: "30",
    src: "truck-05.glb",
    thumbSrc: "truck-05-thumb.png",
  },
  {
    name: "Independent Stage 11 Titanium Truck Blue",
    price: "38",
    src: "truck-03.glb",
    thumbSrc: "truck-03-thumb.png",
  },
]
